import { createBrowserRouter } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { ChannelPage } from './pages/ChannelPage';
import { NotFound } from './pages/NotFound';

export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <HomePage />,
      },
      {
        path: '/c/:channelId',
        element: <ChannelPage />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]);
